<template>
    <div class="d-flex">
        <select
            v-model="hours"
            class="form-control"
            :required="required"
        >
            <option
                v-for="hour in hoursOptions"
                :key="`${hour}h`"
                :value="hour"
            >
                {{ `${hour} hr` }}
            </option>
        </select>
        <select
            v-model="mins"
            class="form-control"
        >
            <option
                v-for="min in minsOptions"
                :key="`${min}m`"
                :value="min"
            >
                {{ `${min} min` }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "DurationSelectComponent",
    props: {
        value: {
            required: true,
        },
        required: {
            required: false,
            default: false,
        },
    },
    data() {
        return {
            hours: 0,
            mins: 0,
        };
    },
    computed: {
        hoursOptions() {
            const hours = [];
            for (let i = 0; i < 24; i++) {
                hours.push(i);
            }

            return hours;
        },
        minsOptions() {
            const mins = [];
            for (let i = 0; i < 60; i += 10) {
                mins.push(i);
            }

            return mins;
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.hours = 0;
                    this.mins = 0;
                    return;
                }

                const parts = newValue.split(':');
                this.hours = parseInt(parts[0] || 0);
                this.mins = parseInt(parts[1] || 0);
            }
        },
        hours: {
            handler(){
                this.emitChange();
            },
        },
        mins: {
            handler() {
                this.emitChange();
            },
        }
    },
    methods: {
        emitChange() {
            this.$emit('input', `${this.hours}:${this.mins}`)
        }
    },
}
</script>

<style scoped>
.d-flex {
    gap: .5rem;
}
.form-control {
    max-width: 8rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/DurationSelectComponent.vue